import React, { useState } from 'react';

function LeadTemplateModal({ templates, onSelect, onCancel, onDelete }) {
  const [selectedId, setSelectedId] = useState('');

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Lead-Vorlage laden</h2>
        <p>Du hast gespeicherte Vorlagen. Möchtest du eine Vorlage laden oder ohne fortfahren?</p>
        <select
          value={selectedId}
          onChange={e => setSelectedId(e.target.value)}
        >
          <option value="">-- Keine Vorlage auswählen --</option>
          {templates.map(t => (
            <option key={t.id} value={t.id}>{t.name} ({t.type})</option>
          ))}
        </select>
        <div style={{ marginTop: 16 }}>
          <div className="button-row">
            <button
              className="template-btn"
              onClick={() => selectedId ? onSelect(selectedId) : onCancel()}
              disabled={selectedId === ''}
            >
              Vorlage laden
            </button>
            <button className="template-btn" onClick={onCancel}>
              Ohne Vorlage fortfahren
            </button>
            <button
              className="template-btn delete-btn"
              onClick={() => onDelete(selectedId)}
              disabled={!selectedId}
            >
              Vorlage löschen
            </button>
          </div>
        </div>
      </div>
      <style>{`
        .modal-overlay {
          position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
          background: rgba(0,0,0,0.3); display: flex; align-items: center; justify-content: center; z-index: 1000;
        }
        .modal-content {
          background: #fff; padding: 32px; border-radius: 8px; min-width: 320px; box-shadow: 0 2px 16px rgba(0,0,0,0.2);
        }
        select { width: 100%; padding: 8px; margin-top: 8px; }
        .button-row {
          display: flex;
          gap: 12px;
          margin-top: 12px;
        }
        .template-btn {
          flex: 1 1 0;
          padding: 10px 0;
          min-width: 0;
          background: #f5f5f5;
          border: 1px solid #bbb;
          border-radius: 4px;
          font-size: 1rem;
          cursor: pointer;
          transition: background 0.2s, border 0.2s, color 0.2s;
          color: #222;
        }
        .template-btn:disabled {
          background: #eee;
          color: #aaa;
          cursor: not-allowed;
        }
        .template-btn.delete-btn {
          background: #d32f2f;
          border-color: #d32f2f;
          color: #222;
        }
        .template-btn.delete-btn:disabled {
          background: #eee;
          color: #aaa;
          border-color: #eee;
        }
        .template-btn:not(:disabled):hover,
        .template-btn:not(:disabled):focus {
          background: #e3f0fa;
          border-color: #1976d2;
        }
        .template-btn.delete-btn:not(:disabled):hover,
        .template-btn.delete-btn:not(:disabled):focus {
          background: #b71c1c;
          border-color: #b71c1c;
          color: #222;
        }
      `}</style>
    </div>
  );
}

export default LeadTemplateModal; 